import { IMapControlParam } from '@/types/map'

declare let BMap: any;
declare let BMapLib: any;
declare const BMAP_ANCHOR_TOP_LEFT: any;
declare const BMAP_ANCHOR_BOTTOM_LEFT: any;
declare const BMAP_ANCHOR_TOP_RIGHT: any;
declare const BMAP_ANCHOR_BOTTOM_RIGHT: any;

declare const BMAP_NAVIGATION_CONTROL_LARGE: any; //标准的平移缩放控件（包括平移、缩放按钮和滑块）
declare const BMAP_NAVIGATION_CONTROL_SMALL: any;//仅包含平移和缩放按钮
declare const BMAP_NAVIGATION_CONTROL_PAN: any;//仅包含平移按钮
declare const BMAP_NAVIGATION_CONTROL_ZOOM: any;//仅包含缩放按钮

//百度地图平移缩放控件
export class NavigationControlBD {
    private static instances: Map<string, any>;//一个BMap.Map对应一个Control
    private view: any;
    private control: any;//平移缩放控件
    private visible: boolean;
    private anchor: string;//"top-left"\"top-right"\"bottom-left"\"bottom-right"
    private xoffset: number;
    private yoffset: number;
    private type: string;//平移缩放控件的类型
    private showZoomInfo: boolean;//是否显示级别提示信息
    private enableGeolocation: boolean;//控件是否集成定位功能，默认为false

    constructor(view: any, option?: any) {
        this.view = view;
        this.visible = false;
        this.anchor = "top-left";
        this.xoffset = 0;
        this.yoffset = 0;
        this.type = "large";
        this.showZoomInfo = true;
        this.enableGeolocation = false;
        if (option.showZoomInfo) {
            this.showZoomInfo = option.showZoomInfo;
        }
        if (option.enableGeolocation) {
            this.enableGeolocation = option.enableGeolocation;
        }
        //为地图添加一个控件
        this.control = new BMap.NavigationControl({
            showZoomInfo: this.showZoomInfo,
            enableGeolocation: this.enableGeolocation
        });
        this.view.addControl(this.control);
    }

    public static getInstance(view: any, options?: any): NavigationControlBD {
        let id = view.getContainer().id;
        if (!NavigationControlBD.instances) {
            NavigationControlBD.instances = new Map();
        }
        let instance = NavigationControlBD.instances.get(id);
        //若没有view对应的实例，则重新创建一个
        if (!instance) {
            instance = new NavigationControlBD(view, options);
            NavigationControlBD.instances.set(id, instance);
        } else if (options) {
            ////两个特殊参数单独处理
            let en = options?.enableGeolocation;
            let sh = options?.showZoomInfo
            if (en || sh) {
                instance.view.removeControl(instance.control);
                instance = new NavigationControlBD(view, options);
                NavigationControlBD.instances.set(id, instance);
            }
        }
        return instance;
    }

    // public static destory() {
    //     (NavigationControlBD.instances as any) = null;
    // }

    public async set(params: IMapControlParam) {
        if (!this.view) {
            //地图未创建，直接返回
            return;
        }
        let isRemove: boolean = params.options?.remove || false;
        if (isRemove) {
            await this._remove();
            return;
        }
        this.visible = params.visible || false;
        await this._setVisible();
        this.anchor = params.anchor || "top-left";
        await this._setAnchor();
        this.type = params.options?.naviType || "large";
        await this._setType();
        this.xoffset = params.options?.xoffset || 0;
        this.yoffset = params.options?.yoffset || 0;
        await this._setOffset();
    }

    //删除自身
    private async _remove() {
        if (!this.view) {
            return;
        }
        let id = this.view.getContainer().id;
        let result = NavigationControlBD.instances.delete(id);
        this.view.removeControl(this.control);
        this.view == null;
    }
    //设置锚点
    private async _setAnchor() {
        let ca: string;
        switch (this.anchor) {
            case "bottom-left":
                ca = BMAP_ANCHOR_BOTTOM_LEFT;
                break;
            case "top-right":
                ca = BMAP_ANCHOR_TOP_RIGHT;
                break;
            case "bottom-right":
                ca = BMAP_ANCHOR_BOTTOM_RIGHT;
                break;
            case "top-left":
            default:
                ca = BMAP_ANCHOR_TOP_LEFT;
                break;
        }
        this.control.setAnchor(ca);
    }
    //设置偏移
    private async _setOffset() {
        this.control.setOffset(new BMap.Size(this.xoffset, this.yoffset));
    }
    //设置是否可见
    private async _setVisible() {
        if (this.visible) {
            this.control.show()
        } else {
            this.control.hide();
        }
    }
    //设置类型
    private async _setType() {
        let ty: string;
        switch (this.type) {
            case "zoom":
                ty = BMAP_NAVIGATION_CONTROL_ZOOM;
                break;
            case "small":
                ty = BMAP_NAVIGATION_CONTROL_SMALL;
                break;
            case "pan":
                ty = BMAP_NAVIGATION_CONTROL_PAN;
                break;
            case "large":
                ty = BMAP_NAVIGATION_CONTROL_LARGE;
                break;
            default:
                ty = BMAP_NAVIGATION_CONTROL_ZOOM;
                break;
        }
        this.control.setType(ty);
    }
};